import React, { Component, Fragment } from 'react';
import { withRouter } from '../WithRouterHOC';
import { Button, message, Modal } from 'antd';
import {
  SyncOutlined,
  CaretRightOutlined,
  CaretLeftOutlined,
  LoadingOutlined,
  RightOutlined,
} from '@ant-design/icons';
import * as Map from 'immutable';
import qs from 'qs';
import WEBIM from '../../store/WebNim';
import Util from '../../script/util';
import HTTP from '../../script/service';
import {
  _change_ds_modal,
  _open_my_center,
  _change_nim_chat,
  _new_room_window,
  _new_nim_window,
  _tip_off,
  _h5_link_to,
  _anly_seng_custom,
  _change_affinity_modal,
  _dssp_show_event,
} from '../../store/Action';
import IframeModal from '../../components/iframModal/IframModal';
import LegalRights from '../legalRights';
import MsgScroll from '../msgScroll';
import AudioModal from './audioModal';
import store from '../../store/store';

const nimCmd = {
  '1-1': {
    from: { type: 'cmd', text: '玩家给你下单但还未支付, 请积极与玩家联系哦~' },
    to: { type: 'text', text: '老板~ 您的订单还未支付哦!' },
  },
  '2-1': {
    from: {
      type: 'cmd',
      text: '下单成功，若超时大神未接单，<span style="color: #f54182">下单钻石将退回至您的账号余额，请留意钻石数量变化。</span>',
    },
    to: { type: 'text', text: '我发起了一笔新订单，赶快接单吧![{描述}]' },
  },
  '3-1': {
    from: { type: 'cmd', text: '服务时间快到了，请开始服务吧!' },
    to: {
      type: 'text',
      text: '我会按照服务时间开始哦，如果时间有变化请与我沟通~',
    },
  },
  '4-1': {
    from: {
      type: 'cmd',
      text: '你已经确认开始服务! 有任何问题请和玩家及时协商。',
    },
    to: { type: 'text', text: '我已经确认开始服务! 有任何问题请和我协商。' },
  },
  '5-1': {
    from: { type: 'cmd', text: '服务已完成，等待玩家给你作出评价!' },
    to: {
      type: 'text',
      text: '服务已完成，请对我的服务作出评价。 五星好评哦~ 谢谢!',
    },
  },
  '5-2': {
    from: { type: 'cmd', text: '玩家已对你作出评价!' },
    to: { type: 'text', text: '感谢您对我的评价，下次再找我玩哦~' },
  },
  '6-1': {
    from: {
      type: 'cmd',
      text: '大神已收到你的退款请求，退款金额：[{钻石数}]。过时未处理，视为同意退款。',
    },
    to: {
      type: 'cmd',
      text: '玩家发起退款请求，请尽快处理。过时未处理，视为同意退款。',
    },
  },
  '7-1': {
    from: { type: 'cmd', text: '你已同意退款，系统将在24小时内退款给玩家。' },
    to: {
      type: 'cmd',
      text: '大神已经同意退款，系统将在24小时内处理，请注意查收。',
    },
  },
  '8-1': {
    from: { type: 'cmd', text: '您已经拒绝退款，请耐心和玩家沟通。' },
    to: { type: 'cmd', text: '大神拒绝退款，建议您和大神协商或者提交维权申请' },
  },
  '8-1-1': {
    from: {
      type: 'text',
      text: '大神拒绝订单[{订单号}]的退款申请，建议您和大神协商或者提交维权申请',
    },
    to: {
      type: 'text',
      text: '大神拒绝订单[{订单号}]的退款申请，建议您和大神协商或者提交维权申请',
    },
  },
  '9-1': {
    from: {
      type: 'cmd',
      text: '订单[{订单号}]的维权申请已提交成功，请耐心等待客服裁决',
    },
    to: {
      type: 'cmd',
      text: '玩家已向系统提交了订单[{订单号}]的维权申请，请提供您的维权资料，以便客服裁决',
    },
  },
  '9-1-1': {
    from: { type: 'text', text: '您已经提交维权申请，请耐心等待客服处理。' },
    to: { type: 'text', text: '您已经提交维权申请，请耐心等待客服处理。' },
  },
  '10-1': {
    from: {
      type: 'text',
      text: '客服裁决订单[{订单号}]你维权失败，订单关闭。',
    },
    to: { type: 'text', text: '客服裁决订单[{订单号}]你维权失败，订单关闭。' },
  },
  '10-1-1': {
    from: {
      type: 'text',
      text: '客服裁决订单[{订单号}]你维权成功，订单完成。',
    },
    to: { type: 'text', text: '客服裁决订单[{订单号}]你维权成功，订单完成。' },
  },
  '10-2': {
    from: {
      type: 'text',
      text: '客服裁决订单[{订单号}]你维权成功，订单关闭，系统24小时内会进行退款。请注意查收~',
    },
    to: {
      type: 'text',
      text: '客服裁决订单[{订单号}]你维权成功，订单关闭，系统24小时内会进行退款。请注意查收~',
    },
  },
  '10-2-1': {
    from: {
      type: 'text',
      text: '客服裁决订单[{订单号}]你维权失败，订单关闭，系统24小时内会退款给玩家。',
    },
    to: {
      type: 'text',
      text: '客服裁决订单[{订单号}]你维权失败，订单关闭，系统24小时内会退款给玩家。',
    },
  },
  '11-1': {
    from: {
      type: 'text',
      text: '由于您未发及时提交订单[{订单号}]的维权资料，订单退款失败。',
    },
    to: {
      type: 'text',
      text: '由于您未发及时提交订单[{订单号}]的维权资料，订单退款失败。',
    },
  },
  '11-1-1': {
    from: {
      type: 'text',
      text: '用户放弃订单[{订单号}]的维权申请，订单不退款，会按照正常流程结算',
    },
    to: {
      type: 'text',
      text: '用户放弃订单[{订单号}]的维权申请，订单不退款，会按照正常流程结算',
    },
  },
  '12-1': {
    from: {
      type: 'cmd',
      text: '您已取消订单[{订单号}]，<span style="color: #f54182">下单钻石将退回至您的账号余额，请留意钻石数量变化。</span>',
    },
    to: {
      type: 'cmd',
      text: '玩家已取消订单[{订单号}]',
    },
  },
  '12-2': {
    from: {
      type: 'cmd',
      text: '您已拒绝订单[{订单号}]，有任何疑问请主动与用户沟通。',
    },
    to: {
      type: 'cmd',
      text: '大神已拒绝订单[{订单号}]，<span style="color: #f54182">下单钻石将退回至您的账号余额，请留意钻石数量变化。</span>',
    },
  },
  '14-1': {
    from: {
      type: 'cmd',
      text: '由于你未及时接单， 订单[{订单号}]已过期。将全款退还给用户',
    },
    to: {
      type: 'cmd',
      text: '由于[{大神}]未及时接单，<span style="color: #f54182">订单[{订单号}]已过期，下单钻石将退回至您的账号余额，请留意钻石数量变化。</span>',
    },
  },
  '20-0': {
    from: {
      type: 'text',
      text: '您当前所属的[{公会名称}]已被封停，您已成为官方平台签约的大神。陪玩订单将按照官方比例进行分成。给您带来不便请谅解。感谢长期对本平台的支持。有任何问题请联系平台官方客服.',
    },
    to: {
      type: 'text',
      text: '您当前所属的[{公会名称}]已被封停，您已成为官方平台签约的大神。陪玩订单将按照官方比例进行分成。给您带来不便请谅解。感谢长期对本平台的支持。有任何问题请联系平台官方客服.',
    },
  },
  '20-1': {
    from: { type: 'text', text: '你已通过公会[{公会名称}]管理员审核。' },
    to: { type: 'text', text: '你已通过公会[{公会名称}]管理员审核。' },
  },
  '20-2': {
    from: { type: 'text', text: '公会[{公会名称}]管理员拒绝你的入会申请。' },
    to: { type: 'text', text: '公会[{公会名称}]管理员拒绝你的入会申请。' },
  },
  '20-3': {
    from: { type: 'text', text: '你已与公会[{公会名称}]协商解约成功~' },
    to: { type: 'text', text: '你已与公会[{公会名称}]协商解约成功~' },
  },
  '20-4': {
    from: { type: 'text', text: '你已与公会[{公会名称}]自动解约。' },
    to: { type: 'text', text: '你已与公会[{公会名称}]自动解约。' },
  },
  '20-5': {
    from: { type: 'text', text: '你申请的[{资质名称}]已通过系统认证~' },
    to: { type: 'text', text: '你申请的[{资质名称}]已通过系统认证~' },
  },
  '20-6': {
    from: {
      type: 'text',
      text: '你申请的[{资质名称}]被系统拒绝， 拒绝原因：[{拒绝原因}]。',
    },
    to: {
      type: 'text',
      text: '你申请的[{资质名称}]被系统拒绝， 拒绝原因：[{拒绝原因}]。',
    },
  },
  '0-0': {
    from: {
      type: 'text',
      text: '有很多漂亮的小姐姐在线哦，请告诉我你的需求! [可爱]',
    },
    to: {
      type: 'text',
      text: '有很多漂亮的小姐姐在线哦，请告诉我你的需求! [可爱]',
    },
  },
  '30-1': {
    from: { type: 'cmd', text: '您已屏蔽对方的消息' },
    to: { type: 'cmd', text: '对方屏蔽了您的消息' },
  },
  '30-2': {
    from: { type: 'cmd', text: '您已取消屏蔽对方的消息' },
    to: { type: 'cmd', text: '对方取消了屏蔽您的消息' },
  },
  '40-1': {
    from: { type: 'cmd', text: '关注成功，去打个招呼吧~' },
    to: { type: 'cmd', text: '对方关注你了哦~ 去打个招呼吧 ~' },
  },
  '40-2': {
    from: { type: 'cmd', text: '取消关注成功~' },
    to: { type: 'cmd', text: '' },
  },
  '40-3': {
    from: { type: 'cmd', text: '关注成功，去打个招呼吧~' },
    to: { type: 'cmd', text: '对方关注你了哦~ 去打个招呼吧 ~' },
  },
};
const tuikuanMsg = {
  1: '不想打了',
  2: '协商一致退款',
  3: '大神没有时间',
  4: '大神水平差',
  5: '大神服务态度恶劣',
  6: '大神未履行服务',
};
const untuikuanMsg = {
  1: '已在约定时间陪玩',
  2: '用户恶意捣乱诬陷',
  3: '已在陪玩中',
  4: '其他',
};
const getBracketsMsg = (msg) => {
  let fitMsg = msg.match(/\{[^}]+\}/);
  if (fitMsg[0]) return fitMsg[0];
  return '';
};
class Msgs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      msgs: [],
      showMsgs: [],
    };
  }
  componentWillUnmount() {
    clearTimeout(this.stime100);
    clearTimeout(this.stime150);
    clearTimeout(this.stime200);
    this.setState = () => {
      return;
    };
  }
  //验证是否更新
  shouldComponentUpdate(newProps, newState) {
    //聊天对象不同
    if (
      !Map.is(Map.fromJS(this.props.me), Map.fromJS(newProps.me)) ||
      !Map.is(Map.fromJS(this.props.to), Map.fromJS(newProps.to))
    ) {
      this.groupMessages();
    }
    //聊天对象相同,有新消息
    else if (
      this.props?.base?.webim_visible == false &&
      newProps?.base?.webim_visible == true
    ) {
      this.groupMessages();
    }
    return true;
  }
  //初始化
  componentDidMount() {
    WEBIM.onConfigFn('_SET_CURR_MESSAGE', this.groupMessage);
    WEBIM.onConfigFn('_SET_CURR_MESSAGES', this.groupMessages);
  }
  //重新组装历史消息-多
  groupMessages = () => {
    this.myScroll && this.myScroll.destroy();
    if (!WEBIM.msgs[WEBIM.to.id] || WEBIM.msgs[WEBIM.to.id].length == 0) {
      this.setState({ msgs: [], loadHistory: false });
    } else {
      let msgs = WEBIM.msgs[WEBIM.to.id].slice(-20);
      this.setState({ msgs, loadHistory: false }, () => {
        //补全服务器数据
        this.loadServerDaTa([...msgs]);
        this.myScroll && this.myScroll.scrollToBottom();
      });
    }
  };
  //重新组装历史消息-单
  groupMessage = (msg, idServer) => {
    const { msgs, loadHistory } = this.state;
    if (idServer || idServer == 0) {
      msgs.forEach((msgR) => {
        if (msgR.idClient == msg.idClient) msgR = { ...msg };
      });
    } else {
      msgs.push(msg);
      //补全服务器数据
      this.loadServerDaTa([{ ...msg }]);
    }
    this.setState({ msgs }, () => {
      if (!idServer && idServer != 0 && !loadHistory) {
        if (msg.flow == 'in') {
          this.myScroll && this.myScroll.addCount();
        } else {
          this.myScroll && this.myScroll.scrollToBottom(0);
        }
      }
    });
  };
  //滚动到底部
  scrollByTop = () => {
    const { msgs, loadHistory } = this.state;
    if (loadHistory) return;
    //满足加载历史 数据条件
    let allMsgs = WEBIM.msgs[WEBIM.to.id];
    if (allMsgs && allMsgs.length > msgs.length) {
      this.setState({ loadHistory: true }, () => {
        let oldN = -1 * msgs.length;
        let newMsgs = allMsgs.slice(oldN - 20, oldN);
        this.setState(
          { msgs: newMsgs.concat(msgs), loadHistory: false },
          () => {
            //补全服务器数据
            this.loadServerDaTa([...newMsgs]);
            clearTimeout(this.stime150);
            this.stime150 = setTimeout(() => {
              this.myScroll && this.myScroll.update(11);
            }, 150);
          }
        );
      });
    }
  };
  //举报
  tipoff = () => {
    const { to } = this.props;
    if (to) {
      _tip_off({
        type: 1,
        reportType: 1,
        reportedPersonId: Util.$analyToUid(to.account),
      });
    }
  };
  //进入个人中心
  openMyCenter = (user, msg) => {
    if (user.custom) {
      if (msg?.action == '115-2') {
        _change_nim_chat();
        _open_my_center({
          tab: 'tab9',
          isOpenGodScore: true,
          time: new Date().getTime(),
        });
      }
    }
  };
  //进入个人主页
  onEndUserMain = (user) => {
    if (user.custom && user.custom?.ifGod == 1) {
      _change_nim_chat();
      _change_ds_modal({
        dsid: Util.$analyToUid(user.account),
        jnid: null,
        ehot: false,
      });
    }
  };
  //进入大神首页
  openDsInfo = (god) => {
    _change_nim_chat();
    const dsid = god.customText ? god.customText.dsid : god.dsid;
    const categoryId = god.customText
      ? god.customText.categoryId
      : god.categoryId;
    _change_ds_modal({
      dsid: dsid,
      jnid: categoryId,
      ehot: false,
    });
  };
  //进入直播间
  inRoom = (roomid, roomname, joinType = null, msg) => {
    this.props.close && this.props.close();
    _change_nim_chat();
    _new_room_window(
      {
        roomid: roomid,
        roomname: roomname,
      },
      this.props.history,
      null,
      joinType
    );
  };
  // 抢单
  grabOrder = (msg, type) => {
    if (msg?.custom?.cardInfo?.roomid) {
      const { msgId, roomid, roomName } = msg.custom.cardInfo;
      HTTP._get_grab_order_status({ roomid, msgId }).then((res) => {
        if (res?.code === 200) {
          this.inRoom(roomid, roomName, type);
        } else {
          message.info(res?.message ?? '当前派单已失效');
        }
      });
    } else {
      message.error('当前派单已失效');
    }
    if (msg?.custom?.cardInfo?.categoryId) {
      // 上报
      _dssp_show_event({
        page_name: '消息',
        tab_name: `聊天页`,
        sub_tab_name: ``,
        scene_category: `消息`,
        scene_name: `聊天场景`,
        scene_value: {
          dispatch_type: msg.custom.cardInfo.categoryId,
          dispatch_room_id: msg.custom.cardInfo.roomid,
        },
      });
    }
  };
  //打开聊天窗口
  followP2PChart = (param) => {
    let account = Util.$analyToAccount(param.uid);
    let to = {
      id: `p2p-${account}`,
      scene: 'p2p',
      account: account,
      jnid: null,
    };
    //标注
    _new_nim_window(to);
  };
  //复制
  copyLink = (id, e) => {
    let dom = document.querySelector(`input[name="link-${id}"]`);
    if (dom?.value) {
      Util.copyLink(dom.value, () => {
        message.success('链接复制成功!');
      });
    }
    e.stopPropagation();
  };
  //H5地址
  openNoticeLink = (link) => {
    _h5_link_to(link).then((res) => {
      if (res.params.roomid) {
        _new_room_window(
          {
            roomid: res.params.roomid,
            roomname: res.params.roomname,
          },
          this.props.history
        );
      } else if (res.params.dsid) {
        _change_nim_chat();
        _change_ds_modal({
          dsid: res.params.dsid,
          jnid: res.params.jnid,
          ehot: false,
        });
      } else {
        this.iframeElement.showModal(res.url + '?' + qs.stringify(res.params));
      }
    });
  };
  // 打开工单H5
  openWorkOrder = (jumpType) => {
    if (jumpType != null) {
      HTTP._get_work_order_link({ jumpType }).then((res) => {
        if (res?.code === 200 && res.data?.workOrderUrl) {
          store.dispatch({
            type: 'change_global_iframe_visible',
            data: {
              globalIframe: {
                visible: true,
                url: `${res.data.workOrderUrl}&isMobile=1`,
              },
            },
          });
        }
      });
    }
  };
  //显示公共iframe
  showIframeModal = (url) => {
    _h5_link_to(url).then((res) => {
      this.iframeElement.showModal(res.url + '?' + qs.stringify(res.params));
    });
  };
  //普通文本消息
  showDefaultText = (msg, text) => {
    const { me, to } = this.props;
    try {
      return (
        <div className={`m-row from-${msg.flow}`}>
          {msg.flow === 'out' ? (
            <div className="cover" onClick={this.onEndUserMain.bind(this, me)}>
              <img alt="" src={Util.transImgUrl(me?.avatar, '45x45')} />
            </div>
          ) : (
            <div className="cover" onClick={this.onEndUserMain.bind(this, to)}>
              <img alt="" src={Util.transImgUrl(to?.avatar, '45x45')} />
            </div>
          )}
          <div className="m-detail">
            {!msg.idServer || msg.status === 'fail' ? (
              <span className="msg-send-ing animated fadeIn">
                {msg.idServer == 0 || msg.status === 'fail' ? (
                  <span
                    className="icon-msg-error"
                    onClick={() => this.againSendMsg(msg, 1)}
                  >
                    {/*错误消息ICON，点击重新发送*/}
                  </span>
                ) : (
                  <SyncOutlined spin />
                )}
              </span>
            ) : null}
            <span className="guide">
              {msg.flow === 'out' ? (
                <CaretRightOutlined />
              ) : (
                <CaretLeftOutlined />
              )}
            </span>
            {text ? (
              <div
                className="m-innerHTML"
                dangerouslySetInnerHTML={{ __html: text }}
              />
            ) : (
              <div
                className="m-innerHTML"
                dangerouslySetInnerHTML={{ __html: Util.transSessionItem(msg) }}
              />
            )}
          </div>
        </div>
      );
    } catch (error) {
      console.error('nim msg error:', error);
      console.log(text, msg);
      console.log('me', me);
      console.log('to', to);
      _anly_seng_custom(1602, { params: { msg, me, to }, data: error.message });
      return null;
    }
  };
  //被求关注
  bsFllow = (msg) => {
    const { me, to } = this.props;
    return (
      <div className={`m-row from-${msg.flow}`}>
        {msg.flow === 'out' ? (
          <div className="cover" onClick={this.onEndUserMain.bind(this, me)}>
            <img alt="" src={Util.transImgUrl(me.avatar, '45x45')} />
          </div>
        ) : (
          <div className="cover" onClick={this.onEndUserMain.bind(this, to)}>
            <img alt="" src={Util.transImgUrl(to.avatar, '45x45')} />
          </div>
        )}
        <div
          className={`m-detail parent-card${msg.flow === 'out' ? ' my-card-not-bg' : ''}`}
        >
          {!msg.idServer ? (
            <span className="msg-send-ing animated fadeIn">
              <SyncOutlined spin />
            </span>
          ) : null}
          <span className="guide">
            {msg.flow === 'out' ? (
              <CaretRightOutlined />
            ) : (
              <CaretLeftOutlined />
            )}
          </span>
          <div
            className="m-innerHTML"
            onClick={this.openDsInfo.bind(this, {
              dsid: Util.$analyToUid(msg.from),
            })}
          >
            <span className="god-card-parent">
              <h3 className="sub-title">个人名片</h3>
              <div className="god-card ">
                <div className="r-cover">
                  <img
                    alt=""
                    src={Util.transImgUrl(msg.custom.user.avatar, '50x50')}
                  />
                </div>
                <div className="r-detail">
                  <div className="r-title">
                    <label className="nick">{msg.custom.user.nickName}</label>
                  </div>
                  <div className="remark">{msg.custom.user.sign}</div>
                </div>
              </div>
            </span>
          </div>
        </div>
      </div>
    );
  };
  //自定义表情消息
  customEmoji = (msg) => {
    if (!msg.content || typeof msg.content != 'string') {
      return (
        <div className="chat-msg-line center">
          <div className="m-custom">
            当前版本过低，无法正常展示内容，请更新到最新版本。
          </div>
        </div>
      );
    }
    const msgContent = JSON.parse(msg.content);
    let dom = null;
    if (msgContent && msgContent.data) {
      dom = (
        <img
          src={Util.transImgUrl(msgContent.data.catalog)}
          alt={msgContent.data.chartlet}
          title={msgContent.data.chartlet}
        />
      );
    }
    const { me, to } = this.props;
    return (
      <div className={`m-row from-${msg.flow}`}>
        {msg.flow === 'out' ? (
          <div className="cover" onClick={this.onEndUserMain.bind(this, me)}>
            <img alt="" src={Util.transImgUrl(me.avatar, '45x45')} />
          </div>
        ) : (
          <div className="cover" onClick={this.onEndUserMain.bind(this, to)}>
            <img alt="" src={Util.transImgUrl(to.avatar, '45x45')} />
          </div>
        )}
        <div className="m-detail custom-emoji-detail">
          {!msg.idServer || msg.status === 'fail' ? (
            <span className="msg-send-ing animated fadeIn">
              {msg.idServer == 0 || msg.status === 'fail' ? (
                <span
                  className="icon-msg-error"
                  onClick={() => this.againSendMsg(msg, 2)}
                >
                  {/*错误消息ICON，点击重新发送*/}
                </span>
              ) : (
                <SyncOutlined spin />
              )}
            </span>
          ) : null}
          <div className="m-innerHTML">
            <div className="custom-emoji-content">{dom}</div>
          </div>
        </div>
      </div>
    );
  };
  //音频消息
  showAudioText = (msg) => {
    const { me, to } = this.props;
    return (
      <div className={`m-row from-${msg.flow}`}>
        {msg.flow === 'out' ? (
          <div className="cover" onClick={this.onEndUserMain.bind(this, me)}>
            <img alt="" src={Util.transImgUrl(me.avatar, '45x45')} />
          </div>
        ) : (
          <div className="cover" onClick={this.onEndUserMain.bind(this, to)}>
            <img alt="" src={Util.transImgUrl(to.avatar, '45x45')} />
          </div>
        )}
        <div className="m-detail">
          <span className="guide">
            {msg.flow === 'out' ? (
              <CaretRightOutlined />
            ) : (
              <CaretLeftOutlined />
            )}
          </span>
          <div className="m-innerHTML">
            <AudioModal data={msg} />
          </div>
        </div>
      </div>
    );
  };
  //追加数据到列表
  appendMsgList = (msg) => {
    if (!WEBIM.msgs[WEBIM.to.id]) return;
    WEBIM.msgs[WEBIM.to.id].forEach((item) => {
      if (item.idClient == msg.idClient) {
        item.exData = msg.exData;
      }
    });
    const { msgs } = this.state;
    msgs.forEach((item) => {
      if (item.idClient == msg.idClient) {
        item.exData = msg.exData;
        item.updateTime = +new Date();
      }
    });
    this.setState({ msgs }, () => {
      clearTimeout(this.stime100);
      this.stime100 = setTimeout(() => {
        this.myScroll && this.myScroll.update(1);
      }, 100);
    });
  };
  //服务器数据加载
  loadServerDaTa = async (msgs) => {
    if (typeof msgs != 'object' || msgs.length == 0) return;
    let msg = msgs.pop();
    if (msg.exData) {
      this.loadServerDaTa(msgs);
      return;
    }
    //大神资料
    if (
      msg.customText &&
      msg.customText.dsid &&
      msg.customText.action === '0-1'
    ) {
      const dsInfo = await HTTP._get_god_detail({ uid: msg.customText.dsid });
      if (dsInfo.code == 200) {
        msg.exData = dsInfo.data;
      } else {
        msg.exData = {};
      }
      this.appendMsgList(msg);
    }
    //直播间资料
    else if (
      msg.customText &&
      msg.customText.roomid &&
      msg.customText.action === '0-2'
    ) {
      const roomInfo = await HTTP._get_room_card_info({
        roomid: msg.customText.roomid,
      });
      if (roomInfo.code == 200) {
        msg.exData = roomInfo.data;
      } else {
        msg.exData = {};
      }
      this.appendMsgList(msg);
    }
    //系统推荐
    else if (msg.custom && msg.custom.godId && msg.custom.action === '12-3') {
      const godInfo = await HTTP._get_god_detail({ uid: msg.custom.godId });
      if (godInfo.code == 200) {
        msg.exData = godInfo.data;
      } else {
        msg.exData = {};
      }
      this.appendMsgList(msg);
    }
    this.loadServerDaTa(msgs);
  };
  //直播间名片
  roomCard = (msg) => {
    const { me, to, base } = this.props;
    const fromUid = Util.$analyToUid(msg.from);
    let joinType = null;
    if (fromUid !== base.uid) {
      joinType = `2|${fromUid}`;
    }
    return (
      <div className={`m-row from-${msg.flow}`}>
        {msg.flow === 'out' ? (
          <div className="cover" onClick={this.onEndUserMain.bind(this, me)}>
            <img alt="" src={Util.transImgUrl(me.avatar, '45x45')} />
          </div>
        ) : (
          <div className="cover" onClick={this.onEndUserMain.bind(this, to)}>
            <img alt="" src={Util.transImgUrl(to.avatar, '45x45')} />
          </div>
        )}
        <div className="m-detail">
          {!msg.idServer || msg.status === 'fail' ? (
            <span className="msg-send-ing animated fadeIn">
              {msg.idServer == 0 || msg.status === 'fail' ? (
                <span
                  className="icon-msg-error"
                  onClick={() => this.againSendMsg(msg, 1)}
                >
                  {/*错误消息ICON，点击重新发送*/}
                </span>
              ) : (
                <SyncOutlined spin />
              )}
            </span>
          ) : null}
          <span className="guide">
            {msg.flow === 'out' ? (
              <CaretRightOutlined />
            ) : (
              <CaretLeftOutlined />
            )}
          </span>
          <div className="m-innerHTML">
            {msg.exData ? (
              <div className="room-card">
                <div className="r-title">我正在直播，速来围观哦!</div>
                <div className="r-cover">
                  {msg.exData && msg.exData.name ? (
                    <span>
                      {msg.exData ? (
                        <span>
                          <img
                            alt=""
                            onClick={this.inRoom.bind(
                              this,
                              msg.customText.roomid,
                              msg.exData.name,
                              joinType
                            )}
                            src={Util.transImgUrl(
                              msg.exData.extInfo.icon,
                              '175x175'
                            )}
                          />
                          <div className="r-id">
                            <label>ID：{msg.exData.roomid}</label>
                            <span
                              onClick={this.copyLink.bind(this, msg.idServer)}
                            >
                              复制链接
                            </span>
                          </div>
                          <input
                            type="text"
                            autoComplete="off"
                            readOnly
                            name={`link-${msg.idServer}`}
                            defaultValue={`${window.location.origin}/room?roomid=${msg.exData.roomid}`}
                          />
                        </span>
                      ) : null}
                    </span>
                  ) : null}
                </div>
                {msg.exData && msg.exData.name ? (
                  <span>
                    <div className="r-name">
                      {msg.exData.blackTeamRoomInfo ? (
                        <span>{msg.exData.blackTeamRoomInfo.categoryName}</span>
                      ) : (
                        <span>
                          {base.roomMode[msg.exData.extInfo.ctype].text}
                        </span>
                      )}
                      {msg.exData.name}
                    </div>
                  </span>
                ) : null}
              </div>
            ) : (
              <span>loading...</span>
            )}
          </div>
        </div>
      </div>
    );
  };
  //直播间名片
  roomCardNew = (msg) => {
    const { me, to, base } = this.props;
    const roomInfo = msg.custom.shareInfo;
    const roomTypeText = roomInfo.roomTypeName ? (
      roomInfo.roomTypeName
    ) : (
      <span>&nbsp;</span>
    );
    const fromUid = Util.$analyToUid(msg.from);
    let joinType = null;
    if (fromUid !== base.uid) {
      joinType = `2|${fromUid}`;
    }
    return (
      <div className={`m-row from-${msg.flow}`}>
        {msg.flow === 'out' ? (
          <div className="cover" onClick={this.onEndUserMain.bind(this, me)}>
            <img alt="" src={Util.transImgUrl(me.avatar, '45x45')} />
          </div>
        ) : (
          <div className="cover" onClick={this.onEndUserMain.bind(this, to)}>
            <img alt="" src={Util.transImgUrl(to.avatar, '45x45')} />
          </div>
        )}
        <div className="m-detail">
          {!msg.idServer || msg.status === 'fail' ? (
            <span className="msg-send-ing animated fadeIn">
              {msg.idServer == 0 || msg.status === 'fail' ? (
                <span
                  className="icon-msg-error"
                  onClick={() => this.againSendMsg(msg, 1)}
                >
                  {/*错误消息ICON，点击重新发送*/}
                </span>
              ) : (
                <SyncOutlined spin />
              )}
            </span>
          ) : null}
          <span className="guide">
            {msg.flow === 'out' ? (
              <CaretRightOutlined />
            ) : (
              <CaretLeftOutlined />
            )}
          </span>
          <div className="m-innerHTML">
            <div className="room-card">
              <div className="r-title">我正在直播，速来围观哦!</div>
              <div className="r-cover">
                <span>
                  <span>
                    <img
                      alt=""
                      onClick={this.inRoom.bind(
                        this,
                        roomInfo.roomId,
                        roomInfo.roomName,
                        joinType
                      )}
                      src={Util.transImgUrl(roomInfo.pic, '175x175')}
                    />
                    <div className="r-id">
                      <label>ID：{roomInfo.roomId}</label>
                      <span onClick={this.copyLink.bind(this, roomInfo.roomId)}>
                        复制链接
                      </span>
                    </div>
                    <input
                      type="text"
                      autoComplete="off"
                      readOnly
                      name={`link-${roomInfo.roomId}`}
                      defaultValue={`${window.location.origin}/room?roomid=${roomInfo.roomId}`}
                    />
                  </span>
                </span>
              </div>
              <div className="r-name">
                <span>{roomTypeText}</span>
                {roomInfo.roomName}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };
  //去维权
  modifyOrder = (orderId) => {
    this.legalRightsElement.showModal({ orderId }, 'god');
    /*HTTP._get_order_detail({
      uid: this.props.base.uid,
      orderId: orderId,
    }).then((res) => {
      if (res.code == 200) {
        if (res.data.appealStatus !== 2) {
          this.legalRightsElement.showModal(res.data, "god");
        } else {
          message.warning("你已提交过维权申请，无需再次提交。");
        }
      } else {
        message.warning(res.message);
      }
    });*/
  };
  //子弹窗
  toDolMpdal = (custom) => {
    if (!custom.url) {
      return;
    }
    this.showIframeModal(custom.url);
  };

  //大神卡片
  godCard = (msg) => {
    const { me, to, base } = this.props;
    return (
      <div className={`m-row from-${msg.flow}`}>
        {msg.flow === 'out' ? (
          <div className="cover" onClick={this.onEndUserMain.bind(this, me)}>
            <img alt="" src={Util.transImgUrl(me.avatar, '45x45')} />
          </div>
        ) : (
          <div className="cover" onClick={this.onEndUserMain.bind(this, to)}>
            <img alt="" src={Util.transImgUrl(to.avatar, '45x45')} />
          </div>
        )}
        <div className="m-detail">
          <span className="guide">
            {msg.flow === 'out' ? (
              <CaretRightOutlined />
            ) : (
              <CaretLeftOutlined />
            )}
          </span>
          <div className="m-innerHTML">
            {msg.exData && msg.exData.godCategoryList ? (
              <span className="god-card-parent">
                <div
                  className="god-card"
                  onClick={this.openDsInfo.bind(this, {
                    dsid: msg.customText.dsid,
                  })}
                >
                  <div className="r-cover">
                    <img
                      alt=""
                      src={Util.transImgUrl(msg.exData.headPic, '75x75')}
                    />
                    {msg.customText.jnid ? (
                      <input
                        type="text"
                        autoComplete="off"
                        readOnly
                        name={`link-${msg.idServer}`}
                        defaultValue={`${window.location.origin}?dsid=${msg.customText.dsid}&jnid=${msg.customText.jnid}`}
                      />
                    ) : (
                      <input
                        type="text"
                        autoComplete="off"
                        readOnly
                        name={`link-${msg.idServer}`}
                        defaultValue={`${window.location.origin}?dsid=${msg.customText.dsid}`}
                      />
                    )}
                  </div>
                  <div className="r-detail">
                    <div className="r-title">
                      <label className="nick">{msg.exData.nickName}</label>
                    </div>
                    <div className="remark">{msg.exData.specificSign}</div>
                  </div>
                </div>
                <div className="god-cat">
                  {msg.exData.godCategoryList
                    .filter((im) => {
                      if (!msg.customText.jnid) return true;
                      else if (im.categoryId == msg.customText.jnid)
                        return true;
                      else return false;
                    })
                    .map((cat, index) => {
                      return (
                        <div
                          key={`cat-${index}`}
                          className="car-row"
                          onClick={this.openDsInfo.bind(this, {
                            dsid: cat.uid,
                            categoryId: cat.categoryId,
                          })}
                        >
                          <span className="cname zz">{cat.categoryName}</span>
                          {base.rootConfig.lang == 'zh_CN' && (
                            <span className="cdetail">
                              <b>{cat.price}元</b>/{cat.unit}
                            </span>
                          )}
                          {base.rootConfig.lang != 'zh_CN' && (
                            <span className="cdetail">
                              <b>{cat.price * 100}钻</b>/{cat.unit}
                            </span>
                          )}
                        </div>
                      );
                    })}
                </div>
              </span>
            ) : (
              <span>
                {msg.exData ? <span>内容已失效</span> : <span>loading...</span>}
              </span>
            )}
          </div>
        </div>
      </div>
    );
  };
  //用户卡片
  userCard = (msg) => {
    const { me, to } = this.props;
    const userInfo = msg.custom.shareInfo;
    return (
      <div className={`m-row from-${msg.flow}`}>
        {msg.flow === 'out' ? (
          <div className="cover" onClick={this.onEndUserMain.bind(this, me)}>
            <img alt="" src={Util.transImgUrl(me.avatar, '45x45')} />
          </div>
        ) : (
          <div className="cover" onClick={this.onEndUserMain.bind(this, to)}>
            <img alt="" src={Util.transImgUrl(to.avatar, '45x45')} />
          </div>
        )}
        <div
          className={`m-detail parent-card${msg.flow === 'out' ? ' my-card-not-bg' : ''}`}
        >
          {!msg.idServer || msg.status === 'fail' ? (
            <span className="msg-send-ing animated fadeIn">
              {msg.idServer == 0 || msg.status === 'fail' ? (
                <span
                  className="icon-msg-error"
                  onClick={() => this.againSendMsg(msg, 1)}
                >
                  {/*错误消息ICON，点击重新发送*/}
                </span>
              ) : (
                <SyncOutlined spin />
              )}
            </span>
          ) : null}
          <span className="guide">
            {msg.flow === 'out' ? (
              <CaretRightOutlined />
            ) : (
              <CaretLeftOutlined />
            )}
          </span>
          <div
            className="m-innerHTML"
            onClick={this.openDsInfo.bind(this, { dsid: userInfo.uid })}
          >
            <span className="god-card-parent">
              <h3 className="sub-title">个人名片</h3>
              <div className="god-card ">
                <div className="r-cover">
                  <img alt="" src={Util.transImgUrl(userInfo.pic, '50x50')} />
                </div>
                <div className="r-detail">
                  <div className="r-title">
                    <label className="nick">{userInfo.nickname}</label>
                  </div>
                  <div className="remark">{userInfo.sign}</div>
                </div>
              </div>
            </span>
          </div>
        </div>
      </div>
    );
  };
  //大神卡片
  godCardNew = (msg) => {
    const { me, to, base } = this.props;
    const godInfo = msg.custom.shareInfo;
    return (
      <div className={`m-row from-${msg.flow}`}>
        {msg.flow === 'out' ? (
          <div className="cover" onClick={this.onEndUserMain.bind(this, me)}>
            <img alt="" src={Util.transImgUrl(me.avatar, '45x45')} />
          </div>
        ) : (
          <div className="cover" onClick={this.onEndUserMain.bind(this, to)}>
            <img alt="" src={Util.transImgUrl(to.avatar, '45x45')} />
          </div>
        )}
        <div
          className="m-detail"
          onClick={this.openDsInfo.bind(this, {
            ...godInfo,
            dsid: godInfo.godId,
          })}
        >
          <span className="guide">
            {msg.flow === 'out' ? (
              <CaretRightOutlined />
            ) : (
              <CaretLeftOutlined />
            )}
          </span>
          <div className="m-innerHTML">
            <span className="god-card-parent">
              <div className="god-card">
                <div className=" ">
                  <img alt="" src={Util.transImgUrl(godInfo.pic, '75x75')} />
                </div>
                <div className="r-detail">
                  <div className="r-title">
                    <label className="nick">{godInfo.categoryName}</label>
                  </div>
                  <div className="remark">
                    {base.rootConfig.lang == 'zh_CN' && (
                      <span className="cdetail">
                        <b>{godInfo.categoryPrice}</b>元/{godInfo.categoryUnit}
                      </span>
                    )}
                    {base.rootConfig.lang != 'zh_CN' && (
                      <span className="cdetail">
                        <b>{godInfo.categoryPrice * 100}</b>钻/
                        {godInfo.categoryUnit}
                      </span>
                    )}
                  </div>
                </div>
              </div>
              <div className="god-cat">
                <div className="car-row">
                  <span className="cname zz">资质</span>
                  <span className="cdetail">查看资质&nbsp;&nbsp;&gt;</span>
                </div>
              </div>
            </span>
          </div>
        </div>
      </div>
    );
  };
  //风控消息
  riskMsg = (msg) => {
    return (
      <div className="chat-msg-line center">
        <div className="m-warning">
          <p>{msg.text}</p>
        </div>
      </div>
    );
  };
  //官方奖励
  giftMsg = (msg) => {
    const { me, to } = this.props;
    return (
      <div className={`m-row from-${msg.flow}`}>
        {msg.flow === 'out' ? (
          <div className="cover" onClick={this.onEndUserMain.bind(this, me)}>
            <img alt="" src={Util.transImgUrl(me.avatar, '45x45')} />
          </div>
        ) : (
          <div className="cover" onClick={this.onEndUserMain.bind(this, to)}>
            <img alt="" src={Util.transImgUrl(to.avatar, '45x45')} />
          </div>
        )}
        <div
          className={msg.custom.url ? 'm-detail pointer' : 'm-detail'}
          onClick={this.toDolMpdal.bind(this, msg.custom)}
        >
          <span className="guide">
            {msg.flow === 'out' ? (
              <CaretRightOutlined />
            ) : (
              <CaretLeftOutlined />
            )}
          </span>
          <div className="m-innerHTML">
            <div className="prize-list-card">
              {msg?.custom?.title && (
                <div className="prize-list-title">{msg.custom.title}</div>
              )}
              <div
                className="prize-list-content"
                dangerouslySetInnerHTML={{ __html: msg.text }}
              />
              <div className="prize-list-img">
                {msg.custom.prizeList.map((citem, cindex) => {
                  return (
                    <span className="prize-img" key={`citem-${cindex}`}>
                      <div
                        className="cover"
                        style={{
                          backgroundImage: `url(${Util.transImgUrl(citem.img)})`,
                        }}
                      />
                      <label className="number">x{citem.number}</label>
                    </span>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };
  //关注消息
  follow = (msg) => {
    const { me, to } = this.props;
    return (
      <div className={`m-row from-${msg.flow}`}>
        {msg.flow === 'out' ? (
          <div className="cover" onClick={this.onEndUserMain.bind(this, me)}>
            <img alt="" src={Util.transImgUrl(me.avatar, '45x45')} />
          </div>
        ) : (
          <div className="cover" onClick={this.onEndUserMain.bind(this, to)}>
            <img alt="" src={Util.transImgUrl(to.avatar, '45x45')} />
          </div>
        )}
        <div className="m-detail">
          <span className="guide">
            {msg.flow === 'out' ? (
              <CaretRightOutlined />
            ) : (
              <CaretLeftOutlined />
            )}
          </span>
          <div className="m-innerHTML">
            <div className="follow-card">
              <div className="cover">
                <img
                  alt=""
                  src={Util.transImgUrl(msg.custom.avatar, '60x60')}
                />
              </div>
              <span
                className="nick"
                onClick={this.followP2PChart.bind(this, msg.custom)}
              >
                {msg.custom.nickName}
              </span>
              <label>
                {msg.custom.ifFriend === 1 ? '也' : '刚刚'}关注了你哦～
              </label>
            </div>
          </div>
        </div>
      </div>
    );
  };
  //关注消息
  unfollow = (msg) => {
    const { me, to } = this.props;
    return (
      <div className={`m-row from-${msg.flow}`}>
        {msg.flow === 'out' ? (
          <div className="cover" onClick={this.onEndUserMain.bind(this, me)}>
            <img alt="" src={Util.transImgUrl(me.avatar, '45x45')} />
          </div>
        ) : (
          <div className="cover" onClick={this.onEndUserMain.bind(this, to)}>
            <img alt="" src={Util.transImgUrl(to.avatar, '45x45')} />
          </div>
        )}
        <div className="m-detail">
          <span className="guide">
            {msg.flow === 'out' ? (
              <CaretRightOutlined />
            ) : (
              <CaretLeftOutlined />
            )}
          </span>
          <div className="m-innerHTML">
            <div className="follow-card">
              <div className="cover">
                <img
                  alt=""
                  src={Util.transImgUrl(msg.custom.avatar, '60x60')}
                />
              </div>
              <span
                className="nick"
                onClick={this.followP2PChart.bind(this, msg.custom)}
              >
                {msg.custom.nickName}
              </span>
              <label>取消了对你的关注~</label>
            </div>
          </div>
        </div>
      </div>
    );
  };
  // 订单维权相关消息 - 系统消息
  orderDefendMsg = (msg) => {
    const { to } = this.props;
    const { text, custom } = msg;
    let content = custom.content || text;
    const arr = content.match(/\{.+?\}/g);
    if (arr?.length) {
      arr.forEach((n) => {
        let word = n.match(/\w+/);
        if (word?.length) {
          word = word[0];
          content = content.replace(
            n,
            `<b class="text-red">${custom[word]}</b>`
          );
        }
      });
    }
    return (
      <div className={`m-row from-${msg.flow}`}>
        {msg.flow === 'out' ? null : (
          <div className="cover">
            <img alt="" src={Util.transImgUrl(to.avatar, '45x45')} />
          </div>
        )}
        <div className="m-detail">
          <span className="guide">
            <CaretLeftOutlined />
          </span>
          <div
            className="m-innerHTML"
            dangerouslySetInnerHTML={{ __html: content }}
          />
        </div>
      </div>
    );
  };
  //派单消息
  pdEvent = (msg) => {
    const { me, to } = this.props;
    const getSex = (sex) => {
      if (sex == 1) return '女';
      else if (sex == 2) return '男';
      return '不限';
    };
    const getLevel = (level) => {
      if (level == '0' || !level) return '不限';
      return level;
    };
    return (
      <div className={`m-row from-${msg.flow}`}>
        {msg.flow === 'out' ? (
          <div className="cover" onClick={this.onEndUserMain.bind(this, me)}>
            <img alt="" src={Util.transImgUrl(me.avatar, '45x45')} />
          </div>
        ) : (
          <div className="cover" onClick={this.onEndUserMain.bind(this, to)}>
            <img alt="" src={Util.transImgUrl(to.avatar, '45x45')} />
          </div>
        )}
        <div className="m-detail">
          <span className="guide">
            {msg.flow === 'out' ? (
              <CaretRightOutlined />
            ) : (
              <CaretLeftOutlined />
            )}
          </span>
          <div className="m-innerHTML">
            <div className="pd-content">
              <div className="mg-list">
                <p>房间：{msg.custom.cardInfo.roomName}</p>
                <p>主持：{msg.custom.fromInfo.nickanme}</p>
                <div className="df-flex">
                  <p className="df">品类：{msg.custom.cardInfo.categoryName}</p>
                  <p className="df">
                    等级要求：{getLevel(msg.custom.cardInfo.level)}
                  </p>
                  <p className="df">
                    单价：{msg.custom.cardInfo.price || '不限'}
                  </p>
                  <p className="df">
                    性别要求：{getSex(msg.custom.cardInfo.sex)}
                  </p>
                </div>
                <p className="pd-msg">{msg.custom.cardInfo.content}</p>
              </div>
              <span
                className="in-action"
                onClick={this.grabOrder.bind(this, msg, `1`)}
              >
                抢单
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  };
  //公告消息
  noticeEvent = (msg) => {
    const { me, to } = this.props;
    return (
      <div className={`m-row from-${msg.flow}`}>
        {msg.flow === 'out' ? (
          <div className="cover" onClick={this.onEndUserMain.bind(this, me)}>
            <img alt="" src={Util.transImgUrl(me.avatar, '45x45')} />
          </div>
        ) : (
          <div className="cover" onClick={this.onEndUserMain.bind(this, to)}>
            <img alt="" src={Util.transImgUrl(to.avatar, '45x45')} />
          </div>
        )}
        <div className="m-detail">
          <span className="guide">
            {msg.flow === 'out' ? (
              <CaretRightOutlined />
            ) : (
              <CaretLeftOutlined />
            )}
          </span>
          <div className="m-innerHTML">
            <div className="notice-data">
              {msg.custom.pcCover && msg.custom.pcCover !== '' ? (
                <div className="notice-cover">
                  <img alt="" src={Util.transImgUrl(msg.custom.pcCover)} />
                </div>
              ) : null}
              <div className="notice-list">
                {msg.custom.details.map((li, ii) => {
                  return (
                    <div className="notice-item" key={`notice-${ii}`}>
                      <h3>{li.title}</h3>
                      <p>{li.content}</p>
                      {li.link && li.link !== '' ? (
                        <span
                          className="more"
                          onClick={this.openNoticeLink.bind(this, li.link)}
                        >
                          <RightOutlined />
                        </span>
                      ) : null}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };
  // 警告消息
  warnEvent = (msg) => {
    const { me, to } = this.props;
    const { custom } = msg;
    let detail = null;
    if (custom?.detail) {
      detail =
        typeof custom.detail === 'string'
          ? JSON.parse(custom.detail)
          : custom.detail;
    }
    return (
      !!detail && (
        <div className={`m-row from-${msg.flow}`}>
          {msg.flow === 'out' ? (
            <div className="cover" onClick={this.onEndUserMain.bind(this, me)}>
              <img alt="" src={Util.transImgUrl(me.avatar, '45x45')} />
            </div>
          ) : (
            <div className="cover" onClick={this.onEndUserMain.bind(this, to)}>
              <img alt="" src={Util.transImgUrl(to.avatar, '45x45')} />
            </div>
          )}
          <div className="warn-message">
            <div className="warn-data">
              <h3 className="warn-title">{detail.title}</h3>
              <p className="warn-content">{detail.content}</p>
            </div>
          </div>
        </div>
      )
    );
  };
  //自定义消息
  getCustomMsg = (custom, cmd_text) => {
    const { me, to } = this.props;
    if (!cmd_text) return '';
    let text = cmd_text.text;
    if (text.indexOf('[{订单号}]') !== -1) {
      text = text.replace(
        '[{订单号}]',
        `<b className="cyan">[${custom.orderId}]</b>`
      );
    }
    if (text.indexOf('[{大神}]') !== -1) {
      text =
        cmd_text.showType === 'to'
          ? text.replace('[{大神}]', `<b className="cyan">[${to.nick}]</b>`)
          : text.replace('[{大神}]', `<b className="cyan">[${me.nick}]</b>`);
    }
    if (text.indexOf('[{公会名称}]') !== -1) {
      text = text.replace(
        '[{公会名称}]',
        `<b className="cyan">[${custom.orderId}]</b>`
      );
    }
    if (text.indexOf('[{资质名称}]') !== -1) {
      text = text.replace(
        '[{资质名称}]',
        `<b className="cyan">[${custom.orderId}]</b>`
      );
    }
    if (text.indexOf('[{拒绝原因}]') !== -1) {
      text = text.replace(
        '[{拒绝原因}]',
        `<b className="cyan">[${custom.message}]</b>`
      );
    }
    if (text.indexOf('[{描述}]') !== -1) {
      if (!!custom.remark) {
        text = text.replace(
          '[{描述}]',
          `<b className="cyan"><br>备注：${custom.remark}</b>`
        );
      } else {
        text = '';
      }
    }
    if (text.indexOf('[{钻石数}]') !== -1) {
      if (custom.refundDiamond != null) {
        text = text.replace(
          '[{钻石数}]',
          `<b style="color: #f54182;">${custom.refundDiamond}钻</b></div>`
        );
      } else {
        text = '';
      }
    }
    return text;
  };
  //系统推荐大神
  cancelRecommend = (msg) => {
    const { me } = this.props;
    //主动取消方是我，不处理
    if (msg.custom.fromGodUid == this.props.base.uid) return null;
    let cancelCmd = {
      from: {
        type: 'recommend',
        text: '系统向您推荐了相同类型的大神。',
      },
      to: {
        type: 'recommend',
        text: '系统向您推荐了相同类型的大神。',
      },
    };
    let cmd_text;
    //判断显示内容
    if (me.account === msg.from) {
      cmd_text = { ...cancelCmd.from, showType: 'from' };
    } else {
      cmd_text = { ...cancelCmd.to, showType: 'to' };
    }
    let godCategory = [];
    if (msg.exData && msg.exData.godCategoryList) {
      godCategory = msg.exData.godCategoryList;
    }
    let showGodCategory = [];
    if (godCategory && godCategory.length > 0) {
      if (msg.custom.categoryId) {
        let cats = godCategory.filter(
          (item) => item.categoryId == msg.custom.categoryId
        );
        if (cats && cats.length > 0) {
          showGodCategory = [cats[0]];
        } else {
          showGodCategory = [godCategory[0]];
        }
      } else {
        showGodCategory = [godCategory[0]];
      }
    }
    msg.flow = 'out';
    if (showGodCategory.length < 1) {
      return null;
    }
    return (
      <Fragment>
        <div className="chat-msg-line center">
          <div
            className="m-custom"
            dangerouslySetInnerHTML={{
              __html: this.getCustomMsg(msg.custom, cmd_text),
            }}
          />
        </div>
        <div className={`m-row from-${msg.flow}`}>
          <div className="m-detail">
            <span className="guide">
              {msg.flow === 'out' ? (
                <CaretRightOutlined />
              ) : (
                <CaretLeftOutlined />
              )}
            </span>
            <div className="m-innerHTML">
              {msg.exData && showGodCategory ? (
                <span className="god-card-parent">
                  <div
                    className="god-card"
                    onClick={this.openDsInfo.bind(this, {
                      customText: {
                        dsid: msg.custom.godId,
                        categoryId: showGodCategory[0].categoryId,
                      },
                    })}
                  >
                    <div className="r-cover">
                      <img
                        alt=""
                        src={Util.transImgUrl(msg.exData.headPic, '75x75')}
                      />
                      {msg.custom.jnid ? (
                        <input
                          type="text"
                          autoComplete="off"
                          readOnly
                          name={`link-${msg.idServer}`}
                          defaultValue={`${window.location.origin}?dsid=${msg.custom.godId}&jnid=${msg.custom.jnid}`}
                        />
                      ) : (
                        <input
                          type="text"
                          autoComplete="off"
                          readOnly
                          name={`link-${msg.idServer}`}
                          defaultValue={`${window.location.origin}?dsid=${msg.custom.godId}`}
                        />
                      )}
                    </div>
                    <div className="r-detail">
                      <div className="r-title">
                        <label className="nick">{msg.exData.nickName}</label>
                        <span
                          className="link"
                          onClick={this.copyLink.bind(this, msg.idServer)}
                        >
                          复制
                        </span>
                      </div>
                      <div className="remark">{msg.exData.specificSign}</div>
                    </div>
                  </div>
                  <div className="god-cat">
                    {showGodCategory
                      .filter((im) => {
                        if (!msg.custom.jnid) return true;
                        else if (im.categoryId == msg.custom.jnid) return true;
                        else return false;
                      })
                      .map((cat, index) => {
                        return (
                          <div key={`cat-${index}`} className="car-row">
                            <span className="cname">{cat.categoryName}</span>
                            <span className="cdetail">
                              <b>{cat.price}元</b>/{cat.unit}
                            </span>
                          </div>
                        );
                      })}
                  </div>
                </span>
              ) : (
                <span>
                  {msg.exData ? (
                    <span>内容已失效</span>
                  ) : (
                    <span>loading...</span>
                  )}
                </span>
              )}
            </div>
          </div>
        </div>
      </Fragment>
    );
  };
  //打招呼
  sayHello = (msg) => {
    const { me, to } = this.props;
    return (
      <div className={`m-row from-${msg.flow}`}>
        {msg.flow === 'out' ? (
          <div className="cover" onClick={this.onEndUserMain.bind(this, me)}>
            <img alt="" src={Util.transImgUrl(me.avatar, '45x45')} />
          </div>
        ) : (
          <div className="cover" onClick={this.onEndUserMain.bind(this, to)}>
            <img alt="" src={Util.transImgUrl(to.avatar, '45x45')} />
          </div>
        )}
        <div className="m-detail">
          <span className="guide">
            {msg.flow === 'out' ? (
              <CaretRightOutlined />
            ) : (
              <CaretLeftOutlined />
            )}
          </span>
          <div className="m-innerHTML">
            <div
              className="hello-wrapper"
              style={{ height: msg.custom.user.picWall ? '230px' : '135px' }}
            >
              <div className="h-top">
                <span>Hi，我想~跟你聊聊天</span>
                <span
                  onClick={this.openDsInfo.bind(this, {
                    customText: {
                      dsid: msg.custom.user.uid,
                      categoryId: '',
                    },
                  })}
                >
                  看TA主页
                </span>
              </div>
              <div className="h-detail">
                {msg.custom.user.age && (
                  <div className="d-item">我：{msg.custom.user.age}岁</div>
                )}
                {msg.custom.user.birthday && (
                  <div className="d-item">
                    我是：
                    <span>
                      {Util.calcConstellation(msg.custom.user.birthday).name}
                    </span>
                  </div>
                )}
                {msg.custom.user && (
                  <div className="d-item">
                    喜欢玩：<span>{this.getInterest(msg.custom.user)}</span>
                  </div>
                )}
                {msg.custom.user.userLikeSound && (
                  <div className="d-item">
                    喜欢的声音：
                    <span>
                      {msg.custom.user.userLikeSound.map((sound, index) => (
                        <label key={sound.id}>
                          {sound.soundType}
                          {msg.custom.user.userLikeSound.length - 1 == index
                            ? ''
                            : '、'}
                        </label>
                      ))}
                    </span>
                  </div>
                )}
              </div>
              {msg.custom.user.picWall && (
                <div className="h-pic">
                  {msg.custom.user.picWall
                    .split(',')
                    .slice(0, 4)
                    .map((pic, index) => (
                      <img
                        alt="picWall"
                        key={index}
                        src={Util.transImgUrl(pic, '100x100')}
                      ></img>
                    ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };
  //求关注
  sendAskFocus = () => {
    const { me, to } = this.props;
    HTTP._ask_focus({
      uid: Util.$analyToUid(me.account),
      otherUid: Util.$analyToUid(to.account),
    }).then((res) => {
      if (res.code == 200) {
        message.success('关注请求已发送，请耐心等待.');
      } else {
        message.error(res.message);
      }
    });
    //我已关注对方
    if (to.custom.meToOther) return;
  };
  // 消息回复
  reportReply = (msg) => {
    const { me, to } = this.props;
    const { custom } = msg;
    return (
      !!custom && (
        <div className={`m-row from-${msg.flow}`}>
          {msg.flow === 'out' ? (
            <div className="cover" onClick={this.onEndUserMain.bind(this, me)}>
              <img alt="" src={Util.transImgUrl(me.avatar, '45x45')} />
            </div>
          ) : (
            <div className="cover" onClick={this.onEndUserMain.bind(this, to)}>
              <img alt="" src={Util.transImgUrl(to.avatar, '45x45')} />
            </div>
          )}
          <div
            className="work-order-message"
            onClick={() =>
              _tip_off({
                type: 2,
                reportType: 1,
                reportOrderId: custom.reportOrderId,
              })
            }
          >
            <div className="work-order-head">
              <h3 className="title">
                <i className="icon" />
                工单编号
              </h3>
              <p className="order">
                {custom.reportOrderId}{' '}
                <span
                  className="icon-copy"
                  onClick={(e) => {
                    e.stopPropagation();
                    Util.copyLink(custom.reportOrderId);
                  }}
                >
                  复制
                </span>
              </p>
            </div>
            <div className="work-order-center">
              问题描述：
              <span dangerouslySetInnerHTML={{ __html: custom.desc }} />
            </div>
            <div className="work-order-center">
              回复内容：
              <span dangerouslySetInnerHTML={{ __html: custom.content }} />
            </div>
          </div>
        </div>
      )
    );
  };
  // 工单消息模板
  workOrderTemplate = (msg) => {
    const { me, to } = this.props;
    const { custom } = msg;

    const handleClick = (e) => {
      if (e.target.nodeName === 'A') {
        this.openWorkOrder(custom.jumpType);
      }
    };
    const regex = new RegExp(custom.title, 'g');
    const html = msg.text.replace(regex, `<a>${custom.title}</a>`);
    return (
      !!custom && (
        <div className={`m-row from-${msg.flow}`}>
          {msg.flow === 'out' ? (
            <div className="cover" onClick={this.onEndUserMain.bind(this, me)}>
              <img alt="" src={Util.transImgUrl(me.avatar, '45x45')} />
            </div>
          ) : (
            <div className="cover" onClick={this.onEndUserMain.bind(this, to)}>
              <img alt="" src={Util.transImgUrl(to.avatar, '45x45')} />
            </div>
          )}
          <div className="m-detail">
            <span className="guide">
              {msg.flow === 'out' ? (
                <CaretRightOutlined />
              ) : (
                <CaretLeftOutlined />
              )}
            </span>
            <div
              className="m-innerHTML"
              onClick={handleClick}
              dangerouslySetInnerHTML={{ __html: html }}
            />
          </div>
        </div>
      )
    );
  };
  // 跳转模板
  jumpTemplate = (msg) => {
    const { me, to } = this.props;
    const { custom } = msg;

    return (
      !!custom && (
        <div className={`m-row from-${msg.flow}`}>
          {msg.flow === 'out' ? (
            <div className="cover" onClick={this.onEndUserMain.bind(this, me)}>
              <img alt="" src={Util.transImgUrl(me.avatar, '45x45')} />
            </div>
          ) : (
            <div className="cover" onClick={this.onEndUserMain.bind(this, to)}>
              <img alt="" src={Util.transImgUrl(to.avatar, '45x45')} />
            </div>
          )}
          <div className="m-detail">
            <span className="guide">
              {msg.flow === 'out' ? (
                <CaretRightOutlined />
              ) : (
                <CaretLeftOutlined />
              )}
            </span>
            <div className="m-innerHTML">
              <p>{msg.text}</p>
              <p>
                <span
                  className="link"
                  onClick={this.openMyCenter.bind(this, me, custom)}
                >
                  查看详情
                </span>
              </p>
            </div>
          </div>
        </div>
      )
    );
  };
  // 亲密关系模版
  affinityTemplate = (msg, type) => {
    const { me, to } = this.props;
    const { custom } = msg;

    return (
      !!custom && (
        <div className={`m-row from-${msg.flow}`}>
          {msg.flow === 'out' ? (
            <div className="cover" onClick={this.onEndUserMain.bind(this, me)}>
              <img alt="" src={Util.transImgUrl(me.avatar, '45x45')} />
            </div>
          ) : (
            <div className="cover" onClick={this.onEndUserMain.bind(this, to)}>
              <img alt="" src={Util.transImgUrl(to.avatar, '45x45')} />
            </div>
          )}
          <div className="m-detail">
            <span className="guide">
              {msg.flow === 'out' ? (
                <CaretRightOutlined />
              ) : (
                <CaretLeftOutlined />
              )}
            </span>
            <div className="m-innerHTML">
              <p>{msg.text}</p>
              <p>
                <span
                  className="link"
                  onClick={() => this.openAffinity(msg, type)}
                >
                  查看详情
                </span>
              </p>
            </div>
          </div>
        </div>
      )
    );
  };

  peakGameTemplate = (msg) => {
    const { me, to } = this.props;
    const { custom } = msg;
    return (
      !!custom && (
        <div className={`m-row from-${msg.flow}`}>
          {msg.flow === 'out' ? (
            <div className="cover" onClick={this.onEndUserMain.bind(this, me)}>
              <img alt="" src={Util.transImgUrl(me.avatar, '45x45')} />
            </div>
          ) : (
            <div className="cover" onClick={this.onEndUserMain.bind(this, to)}>
              <img alt="" src={Util.transImgUrl(to.avatar, '45x45')} />
            </div>
          )}
          <div className="m-detail">
            <span className="guide">
              {msg.flow === 'out' ? (
                <CaretRightOutlined />
              ) : (
                <CaretLeftOutlined />
              )}
            </span>
            <div className="m-innerHTML">
              <p dangerouslySetInnerHTML={{ __html: custom.weeklyTitle }}></p>
              <p dangerouslySetInnerHTML={{ __html: custom.weeklyContent }}></p>
              <p dangerouslySetInnerHTML={{ __html: custom.arrTitle }}></p>
              <p dangerouslySetInnerHTML={{ __html: custom.arrContent }}></p>
              <p dangerouslySetInnerHTML={{ __html: custom.reminderTitle }}></p>
              <p
                dangerouslySetInnerHTML={{ __html: custom.reminderContent }}
              ></p>
              <p dangerouslySetInnerHTML={{ __html: custom.wishContent }}></p>
              <p>
                <span
                  className="link"
                  onClick={() => this.openPeakGmaeRule(msg)}
                >
                  {custom.ruleContent}
                </span>
              </p>
            </div>
          </div>
        </div>
      )
    );
  };

  openPeakGmaeRule = () => {
    let url = '/game-rank-new?isOpenRule=true';
    _h5_link_to(url).then((res) => {
      this.iframeElement.showModal(res.url + '?' + qs.stringify(res.params));
    });
  };

  openAffinity = (msg, type) => {
    if (type == 'apply') {
      _change_affinity_modal({
        affinityApplyModal: true,
        affinityApplyOrderNo:
          msg?.custom?.orderNo || msg?.custom?.inviteOrderNo,
      });
    } else if (type == 'remove') {
      _change_affinity_modal({
        affinityDeleteModal: true,
        affinityDeleteOrderNo:
          msg?.custom?.orderNo || msg?.custom?.cancelOrderNo,
      });
    } else if (type == 'space') {
      const {
        receiveUid: otherUid,
        sendUid: searchUid,
        intimateRelationId,
      } = msg?.custom;
      _change_affinity_modal({
        affinitySpaceModal: true,
        affinitySpaceData: { otherUid, searchUid, intimateRelationId },
      });
    }
  };
  /**
   * 错误消息重新发送
   * @param msg 消息体
   * @param type 1：普通消息 2：自定义贴图
   */
  againSendMsg = (msg, type) => {
    Modal.confirm({
      title: '提示',
      icon: null,
      closable: true,
      content: <p>消息发送失败，是否重新发送？</p>,
      className: 'daidai-confirm-style',
      cancelText: '取消',
      okText: '确定',
      centered: true,
      onOk: () => WEBIM.sendAgainText(msg, type),
    });
  };
  render() {
    const { msgs, loadHistory } = this.state;
    const { me, to, base } = this.props;
    //时间差
    const getLastTime = (index) => {
      if (index) {
        return msgs[index].time - msgs[index - 1].time > 60000 ? (
          <div className="m-time">{Util.transTime(msgs[index].time)}</div>
        ) : null;
      }
      return <div className="m-time">{Util.transTime(msgs[index].time)}</div>;
    };
    //消息行处理
    const getMsgLine = (msg) => {
      if (msg.type === 'text') {
        if (msg.custom && msg.custom.shareInfo) {
          const { shareType } = msg.custom.shareInfo;
          //房间卡片
          if (shareType === 1) {
            return this.roomCardNew(msg);
          }
          //用户资料卡片
          else if (shareType === 2) {
            return this.userCard(msg);
          }
          //用户技能卡片
          else if (shareType === 3) {
            return this.godCardNew(msg);
          }
        }
        //大神卡片消息
        else if (msg.customText && msg.customText.action === '0-1') {
          return this.godCard(msg);
        }
        //直播间消息
        else if (msg.customText && msg.customText.action === '0-2') {
          return this.roomCard(msg);
        }
        //风控消息
        else if (msg.custom && msg.custom.isRisk) {
          return this.riskMsg(msg);
        }
        //官方奖励
        else if (msg.custom && msg.custom.prizeList) {
          return this.giftMsg(msg);
        }
        //其他自定义消息
        else if (msg.custom) {
          //关注
          if (
            (msg.custom.action === '40-1' || msg.custom.action === '40-3') &&
            to.custom &&
            to.custom.sys
          ) {
            return this.follow(msg);
          }
          //取消关注
          else if (msg.custom.action === '40-2' && to.custom && to.custom.sys) {
            return this.unfollow(msg);
          }
          //系统定义
          else if (msg.custom.action && nimCmd[msg.custom.action]) {
            // todo 2.39.0 订单维权使用新的展示逻辑
            if (
              (msg.custom.action === '10-1' ||
                msg.custom.action === '10-1-1' ||
                msg.custom.action === '10-2' ||
                msg.custom.action === '10-2-1') &&
              msg?.custom?.content
            ) {
              return this.orderDefendMsg(msg);
            }

            let cmd_text;
            let cmd_item = nimCmd[msg.custom.action];
            //判断显示内容
            if (me) {
              if (me.account === msg.from) {
                cmd_text = { ...cmd_item.from, showType: 'from' };
              } else {
                cmd_text = { ...cmd_item.to, showType: 'to' };
              }
            } else {
              if (process.env.CLIENT_ENV !== 'production') {
                console.info(
                  '------------没获取到用户信息，无法判断消息显示类型----------------'
                );
              }
            }
            if (msg.custom.action == '6-1' && me.account != msg.from) {
              return (
                <div className="chat-msg-line center">
                  <div className="m-custom">
                    <p className="b1">
                      玩家申请退款，若订单结束前您还未处理，系统将自动退款给用户
                    </p>
                    <p className="b1">
                      玩家选择退款原因：
                      <b>{tuikuanMsg[msg.custom.reason || 1]}</b>
                      {msg?.custom?.refundDiamond != null && (
                        <>
                          &nbsp;&nbsp;退款金额：{' '}
                          <b>{msg.custom.refundDiamond}钻</b>
                        </>
                      )}
                    </p>
                    <ul className="msg-list">
                      <li>如果您同意，将直接退款给用户</li>
                      <li>如果您拒绝，用户可以申请客服介入处理</li>
                      <li>如果您逾期未处理，系统将自动退款给用户</li>
                    </ul>
                  </div>
                </div>
              );
            } else if (msg.custom.action == '8-1' && me.account != msg.from) {
              return (
                <div className="chat-msg-line center">
                  <div className="m-custom">
                    <p className="b1">
                      大神拒绝退款，建议您和大神协商或者提交维权申请
                    </p>
                    <p className="b1">
                      大神拒绝退款原因：
                      <b>{untuikuanMsg[msg.custom.reason || 1]}</b>
                    </p>
                    <ul className="msg-list">
                      <li>
                        如果您还想退款，请申请维权，客服会介入，将在1个工作日内处理
                      </li>
                      <li>
                        如果您不想继续退款，订单时间结束到了，系统会自动结束订单并结算给大神
                      </li>
                      <li>
                        如果您不处理该订单了，系统将在订单时间结束，自动给大神结算
                      </li>
                    </ul>
                  </div>
                </div>
              );
            } else if (msg.custom.action == '9-1' && me.account != msg.from) {
              return (
                <div className="chat-msg-line center">
                  <div className="m-custom">
                    <p className="b1">
                      玩家已向系统提交了订单[{msg.custom.orderId}]的维权申请!
                    </p>
                    <p className="b1">
                      请提供您的维权资料，以便客服裁决，
                      <span
                        className="link"
                        onClick={this.modifyOrder.bind(
                          this,
                          msg.custom.orderId
                        )}
                      >
                        提交维权信息
                      </span>
                    </p>
                    <p className="b1">
                      如果您不处理该维权信息，客服将判定用户维权成功，订单关闭，全额退款给用户
                    </p>
                    <ul className="msg-list">
                      <li>
                        如果您坚持拒绝退款给用户，请提交维权信息，客服将在1个工作日做出处理
                      </li>
                      <li>
                        如果客服裁决用户维权失败，订单将默认完成，参与正常结算
                      </li>
                      <li>
                        如果客服裁决用户维权成功，订单将关闭，全额退款给用户
                      </li>
                    </ul>
                  </div>
                </div>
              );
            } else if (cmd_text?.type === 'cmd') {
              return (
                <div className="chat-msg-line center">
                  <div
                    className="m-custom"
                    dangerouslySetInnerHTML={{
                      __html: this.getCustomMsg(msg.custom, cmd_text),
                    }}
                  />
                </div>
              );
            } else {
              return this.showDefaultText(
                msg,
                this.getCustomMsg(msg.custom, cmd_text)
              );
            }
          }
          //求关注
          else if (msg.custom.action === '19-2') {
            return this.bsFllow(msg);
          }
          //派单消息
          else if (msg.custom.action === '100-1') {
            return this.pdEvent(msg);
          }
          //官方公告
          else if (msg.custom.action === '100-2') {
            return this.noticeEvent(msg);
          }
          // 警告消息模板
          else if (msg.custom.action === '101-1') {
            return msg?.custom ? this.warnEvent(msg) : null;
          }
          //系统推荐大神
          else if (msg.custom.action === '12-3') {
            return this.cancelRecommend(msg);
          }
          //心动匹配打招呼
          else if (msg.custom.action === '25-1') {
            return this.sayHello(msg);
          }
          // 工单回复消息
          else if (msg.custom.action === '103-5') {
            return this.reportReply(msg);
          }
          // 触发工单消息类型
          else if (msg.custom.action === '105-1') {
            return this.workOrderTemplate(msg);
          }
          // 跳转到大神分
          else if (msg.custom.action === '115-2') {
            return this.jumpTemplate(msg);
          }
          // 亲密关系申请
          else if (msg.custom.action === '117-1') {
            return this.affinityTemplate(msg, 'apply');
          }
          // 亲密关系解除
          else if (msg.custom.action === '117-3') {
            return this.affinityTemplate(msg, 'remove');
          }
          // 亲密关系-亲密空间
          else if (msg.custom.action === '117-5') {
            return this.affinityTemplate(msg, 'space');
          }
          // 巅峰赛消息
          else if (msg.custom.action === '118-2') {
            return this.peakGameTemplate(msg);
          } else if (msg.custom.msgBroad) {
            if (base.rootConfig.lang == 'zh_CN') {
              if (msg.text) {
                return this.showDefaultText(msg);
              } else {
                return (
                  <div className="chat-msg-line center">
                    <div className="m-custom">
                      当前版本过低，无法正常展示内容，请更新到最新版本。
                    </div>
                  </div>
                );
              }
            } else {
              if (base.langDicts) {
                let mBroad = msg.custom.msgBroad;
                while (mBroad.indexOf('{') > -1) {
                  let fitKey = getBracketsMsg(mBroad);
                  let mlen = fitKey.length;
                  let bid = fitKey.substring(1, mlen - 1);
                  if (base.langDicts[base.rootConfig.lang + '-' + bid]) {
                    let langVal =
                      base.langDicts[base.rootConfig.lang + '-' + bid];
                    mBroad = mBroad.replace(fitKey, langVal);
                  } else {
                    mBroad = msg.text;
                  }
                }
                msg.text = mBroad;
                return this.showDefaultText(msg);
              } else {
                return (
                  <div className="chat-msg-line center">
                    <div className="m-custom">
                      当前版本过低，无法正常展示内容，请更新到最新版本。
                    </div>
                  </div>
                );
              }
            }
          }
        }
        return this.showDefaultText(msg);
      } else if (msg.type === 'audio') {
        return this.showAudioText(msg);
      } else if (msg.type === 'custom' && msg.content) {
        return this.customEmoji(msg);
      } else if (msg.type === 'tip') {
        // todo 2022.07.28 新增消息类型，用户信息流插入展示
        return (
          <div className="chat-msg-line center">
            <div className="m-custom">{msg.tip}</div>
          </div>
        );
      } else {
        return this.showDefaultText(msg);
      }
    };
    //消息预警
    const getSensitiveWord = (msg) => {
      if (msg.customText || !msg.custom) return null;
      if (msg.custom.shareInfo) return null;
      if (msg.custom.sensitiveWord && msg.custom.sensitiveWord != '0') {
        return (
          <div className="chat-msg-line center">
            <div className="m-warning">
              <p>
                安全提示：为保障您的个人权益，请勿私下协议和平台外交易，谨防受骗！如发现可疑及时联系客服。
                <span className="warn-repot" onClick={this.tipoff}>
                  点击举报
                </span>
              </p>
            </div>
          </div>
        );
      }
      return null;
    };
    //对方开启屏蔽陌生人
    const getIfDnd = () => {
      if (!to) return null;
      if (!to.fllow) return null;
      if (to.fllow.otherIfDnd == 1 && to.fllow.otherToMe == 0) {
        return (
          <div className="chat-msg-line">
            <div className="chat-msg-line center">
              <div className="other-ifdnd m-custom">
                对方已开启消息防打扰，给TA发送一条关注信息吧~
                <span className="link" onClick={this.sendAskFocus}>
                  求关注~
                </span>
              </div>
            </div>
          </div>
        );
      }
    };
    // 发送消息限制
    const getSendLimit = (msg) => {
      if (!msg.custom) return null;
      if (msg.custom.shareInfo) return null;
      const { errCode = null, errMsg = null } = msg.custom;
      if (
        msg.status !== 'success' &&
        errCode &&
        (errCode === 20005 || errCode === 20006)
      ) {
        return (
          <div className="chat-msg-line">
            <div className="chat-msg-line center">
              <div className="other-ifdnd m-custom">{errMsg}</div>
              <div>
                {errCode === 20005 ? (
                  <Button className="m-send-focus" onClick={this.sendAskFocus}>
                    <i className="icon-add" />
                    求关注
                  </Button>
                ) : (
                  <Button
                    className="m-send-focus"
                    onClick={this.props.addFollow}
                  >
                    <i className="icon-add" />
                    关注TA
                  </Button>
                )}
              </div>
            </div>
          </div>
        );
      }
      return null;
    };
    return (
      <Fragment>
        <div className="chat-all-msgs">
          <MsgScroll
            type="room"
            ref={(el) => (this.myScroll = el)}
            onScrollToTop={this.scrollByTop}
          >
            <div className="msg-html">
              {loadHistory ? (
                <div className="load-history-loading">
                  <LoadingOutlined />
                </div>
              ) : null}
              {msgs.map((msg, index) => {
                return (
                  <div className="chat-msg-line" key={`msg-${index}`}>
                    {getLastTime(index)}
                    {getMsgLine(msg)}
                    {getSensitiveWord(msg)}
                    {getSendLimit(msg)}
                  </div>
                );
              })}
              {getIfDnd()}
            </div>
          </MsgScroll>
        </div>
        <LegalRights
          ref={(el) => (this.legalRightsElement = el)}
          uid={base.uid}
        />
        <IframeModal wrappedComponentRef={(el) => (this.iframeElement = el)} />
      </Fragment>
    );
  }
}

export default withRouter(Msgs, { withRef: true });
